import axios from "axios";
import { InlineEditOrderType } from "../Types/types";

export function isInlineEditOrderDataEqual(object1: InlineEditOrderType, object2: InlineEditOrderType) {
  let res: boolean = true;
  object1.priority_code !== object2.priority_code ? res = false : res = res;
  object1.priority_id !== object2.priority_id ? res = false : res = res;
  object1.asset_description !== object2.asset_description ? res = false : res = res;
  object1.department_code !== object2.department_code ? res = false : res = res;
  object1.department_id !== object2.department_id ? res = false : res = res;
  object1.status_code !== object2.status_code ? res = false : res = res;
  object1.status_id !== object2.status_id ? res = false : res = res;
  object1.type_code !== object2.type_code ? res = false : res = res;
  object1.type_id !== object2.type_id ? res = false : res = res;
  object1.site_details_1 !== object2.site_details_1 ? res = false : res = res;
  object1.wo_labour_cost !== object2.wo_labour_cost ? res = false : res = res;
  object1.wo_material_cost !== object2.wo_material_cost ? res = false : res = res;
  object1.wo_other_cost !== object2.wo_other_cost ? res = false : res = res;
  return res;
}


export const getLocalUtcOffSetValue = (): number => {
  const localUTCString = localStorage.getItem('tzDrawer');
  if (
    localUTCString != undefined &&
    localUTCString != '' &&
    localUTCString !== null
  ) {
    var index = localUTCString!.indexOf('+');
    if (index === -1) {
      index = localUTCString!.indexOf('-');
    }
    if (index !== -1) {
      var substringAfterePlusMinus = localUTCString!.substring(index);
      return parseInt(substringAfterePlusMinus) * 60;
    } else {
      return 0;
    }
  } else {
    return 0;
  }
};

export const getFilteredOrder = async (current_query: string | undefined, applyTheRule: any, section :string) => {
  if (current_query !== undefined && current_query !== '') {
    let jsonString_current_query: string = current_query;
    if(section ==='planning-console-section'){
      let query = current_query.split('?');
       //jsonString_current_query = current_query.slice(0, -1);
       jsonString_current_query = query[0];
    }
    let jsonObject_current_query = JSON.parse(jsonString_current_query);
    if (jsonObject_current_query.f === "plan_id") {
      jsonObject_current_query.f = "ID";
    }
    jsonObject_current_query.t = "andWhere";
    let init_query: string = JSON.stringify(jsonObject_current_query) + '?'
    let planner_query = await applyTheRule('uw_order', 'Cloud Planner')
    current_query = planner_query + init_query;
    let theUrl =
      process.env.REACT_APP_API_GLOBAL_URL +
      `order` +
      `/${0}?where=1$500$` +
      current_query;
    let theResult = await axios.get(theUrl);
    return theResult;
  }
}